// extracted by mini-css-extract-plugin
module.exports = {"switch":"dd31006766--switch--VneCO","indicator":"dd31006766--indicator--ApXPO","disabled":"dd31006766--disabled--J5kyp"};